// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { ProjectReportRow } from '@/report/api/types';

export type ProjectReportType = 'active' | 'upcoming' | 'past';

const PATHS: Record<ProjectReportType, string> = {
  past: '/v1/report/project/past',
  active: '/v1/report/project/active',
  upcoming: '/v1/report/project/upcoming',
};

interface Parameters {
  start?: string;
  end?: string;
}

interface Response {
  data: ProjectReportRow[];
}

/**
 * Requests project report for a given time period.
 *
 * @param type - The type of the report.
 * @param parameters.start - The start of the time period.
 * @param parameters.end - The end of the time period.
 */
export async function getProjectReport(
  type: ProjectReportType,
  parameters: Parameters
) {
  const path = PATHS[type];

  // This API response is expected to be large, so the response is not parsed
  // for performance reasons. Instead, the response type is assumed to be
  // correct and the data is returned directly.
  const { data } = await api.get<Response>(path, { params: parameters });

  return data.data;
}
